import { AUTHED_INFOR_LOCAL_STORAGE } from '@const/auth'
import { get } from '@services/local-storage-service'
import { useEffect, useState } from 'react'

export const useAuth = () => {
  const [authInfo, setAuthInfor] = useState<TAuthDetail.State['informationAuthed']>()

  useEffect(() => {
    const _authInfo = get(AUTHED_INFOR_LOCAL_STORAGE) as TAuthDetail.State['informationAuthed']
    if (_authInfo) setAuthInfor(_authInfo)
  }, [])

  return authInfo
}
